module.exports = __webpack_public_path__ + "img/great-kids.jpg";


//////////////////
// WEBPACK FOOTER
// ./img/great-kids.jpg
// module id = 235
// module chunks = 0